import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { MedicalItemAlertsAndSpecialNeeds } from "@/Patient/Models/MedicalSummary/MedicalItemAlertsAndAllergies";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

import styles from "./AlertPopup.module.scss";

interface IConfirmDeleteMedicalItemPopupProps {
    Model: IPatientMedicalSummaryModel;
}

class AlertPopup extends React.Component<IConfirmDeleteMedicalItemPopupProps, any> {
    public componentDidMount(): void {
        sessionStore.showGlobalOverlay(true);
        $("#__okButton").focus();
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public get alertsRender(): JSX.Element[] {
        // check if has any alerts to display
        let alerts = this.props.Model.get("AlertsToDisplay").toArray();
        let alertsToDisplay = alerts.filter(x => {
            let isDisplay = x.EMRTemplateIsDisplayPopup;

            if (isDisplay && x.EndDate != null && x.EndDate != undefined) {
                isDisplay = moment(x.EndDate) > moment();
            }

            return isDisplay;
        });

        return alertsToDisplay.map((alert, idx) => this.renderAlert(alert, idx));
    }

    public renderAlert(x: MedicalItemAlertsAndSpecialNeeds, idx: number): JSX.Element {
        return (
            <div key={"alert_" + idx} data-cy="alertPopup-details">
                <div className="row">
                    <div className="col-sm-12">
                        <span> <strong>{x.Name} </strong></span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <span> {JSXHelper.BreakStringIntoParagraphs(x.Description, true)} </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="checkbox no-margin">
                            <label>
                                <input id={x.MedicalItemId} type="checkbox" onChange={this.doNotShowAgain.bind(this, x.EMRTemplateId)} />
                                {cacheStore.GetString("DoNotDisplayAgainLabel")}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public render(): JSX.Element {
        return (
            <Popup
                draggable={true}
                titleAlternateComponent={<p className={styles.popupTitle}>{cacheStore.GetString("AlertLabel")}</p>}
                closeTarget={LocalPatientOperations.MedicalSummary.CloseAlertPopup}
                width={550}
                centeredHorizontally={true}
            >
                <div className={`p-body ${styles.alertsWrapper}`}>
                    {this.alertsRender}
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button data-action="save" data-cy="alertPopup-save" id="__okButton" className="btn btn-primary push-right-5" onClick={this.okClick.bind(this)}>{cacheStore.GetString("OKLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private doNotShowAgain(emrTemplateId: any, e: any): void {
        let operation = new LocalEvent(LocalPatientOperations.MedicalSummary.RemoveAlert);
        operation.AddItem("id", emrTemplateId);
        operation.AddItem("checked", e.target.checked);
        LocalEventDispatcher.dispatch(operation);
    }

    private okClick(e: React.MouseEvent<HTMLButtonElement>): void {
        e.preventDefault();
        let operation = new LocalEvent(LocalPatientOperations.MedicalSummary.CloseAlertPopup);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }
}

export { AlertPopup };
